import { or } from '@lumapps/utils/function/predicate/or';
import { isCodeBlock } from '@lumapps/wrex-code-block/utils/isCodeBlock';
import { isQuoteBlock } from '@lumapps/wrex-quote/utils/isQuoteBlock';
import { isParagraph } from '@lumapps/wrex-typography/utils/isParagraph';

export const isAllowedInAlignedWrapper = or(isParagraph, isQuoteBlock, isCodeBlock);
